import { Copyright, FooterData, FooterContent, FooterLinks, FooterLogo, FooterWrapper, LinksColumn, SocialMediaIcons, SocialMediaIcon } from "./styles"
import { categories } from "../../util/sharedData"
import { NavLink } from "react-router-dom"
import FooterBrandLogo from '../../assets/img/celeste-logo.png'
import { P } from "../p/P"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFacebook, faInstagram } from "@fortawesome/free-brands-svg-icons"

export const Footer = () => {
    const icons = [
        {name: 'Facebook', code: faFacebook, url: 'https://www.facebook.com/p/Celeste-Mall-100078098397271/', color: '	#1877F2'},
        {name: 'Instagram', code: faInstagram, url: 'https://www.instagram.com/celeste_highstreetmall', color: 'red'},
        // {name: 'X', code: faXTwitter, url: ''},
    ]
    return (
        <FooterWrapper>
            <FooterData>
                <FooterContent>
                    <FooterLogo src={FooterBrandLogo}></FooterLogo>
                    <P>Get in touch to discover the difference we can make, and the difference you can live.</P>
                    <SocialMediaIcons>
                        {
                            icons.map((icon, idx) => (
                                <a key={idx} href={icon.url} target='_blank' rel='noreferrer'>
                                    <SocialMediaIcon key={idx}>
                                        <FontAwesomeIcon icon={icon.code} color={'black'} />
                                    </SocialMediaIcon>
                                </a>
                            ))
                        }
                    </SocialMediaIcons>
                </FooterContent>
                <FooterLinks>
                    <h4>Helpful Links</h4>
                    {
                        categories.map((category, idx) => (
                            <LinksColumn key={idx}>
                                <NavLink 
                                    to={category.path}
                                    style={({isActive}) => ({
                                        color: isActive ? "blue" : "black",
                                    })}
                                    >
                                    {category.name}
                                </NavLink>
                            </LinksColumn>)
                        )
                    }
                </FooterLinks>
            </FooterData>
            <Copyright>© 2024. Celeste. All rights reserved.</Copyright>
        </FooterWrapper>
    )
}